import { typeInput } from "./JsonLists.js";
import { EMAIL_VALIDATOR } from "helpers/validators.js";

export const validation_IsEmpty = (txt) => {
  var r = false;
  if (txt !== null && txt !== undefined) {
    if (txt.length === 0) {
      r = true;
    } else {
      if (txt.length === 0) {
        r = true;
      }
    }
  } else {
    r = true;
  }
  return r;
};

export const validation_IsValidUrl = (url) => {
  var isValid = true;
  var reg = /^(http|https):\/\/[^ "]+$/;
  if (reg.test(url) === false) {
    isValid = false;
  }
  return isValid;
};

export const validation_IsValidEmail = (email) => {
  var isValid = true;
  var reg = EMAIL_VALIDATOR;
  if (reg.test(email) === false) {
    isValid = false;
  } else {
    var mail = email.toLowerCase();
    if (mail.indexOf("..") >= 0) {
      isValid = false;
    }

    if (mail.indexOf("-") !== -1) {
      if (mail.indexOf("@-") !== -1) {
        isValid = false;
      }
    }
    var d = mail.indexOf("-.");
    if (d !== -1) {
      var o = mail.indexOf("@");
      if (o > 1) {
        isValid = false;
      }
    }
    var y = mail.indexOf(".-");
    if (y !== -1) {
      var w = mail.indexOf("@");
      if (w > 1) {
        isValid = false;
      }
    }
    var n = mail.indexOf("@.");
    if (n !== -1) {
      isValid = false;
    }
    var x = mail.indexOf(".");
    if (x === 0) {
      isValid = false;
    }
  }
  return isValid;
};

export const validation_IsValidDate = (date) => {
  //check if new Date is invalid
  const patternDate = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
  return patternDate.test(date);
};

export const validateSubmit = (embedJson) => {
  let leadsJson = [];
  let errorFields = [];
  for (let i = 0; i < embedJson.length; i++) {
    const element = embedJson[i];
    if (element.TextValue === undefined) {
      element.TextValue = "";
    }
    let type = typeInput[element.template].dataType;
    let isRequired = element.fields.required;
    let isDisplay = element.fields.display;
    let isReuse = element.fields.tempsave;
    let isDownloadName = element.fields.downloadname;
    let isReadOnly = element.fields.readonly;
    let isIncludeInEmailSubject = element.fields.includeinemailsubject;
    let item = {};
    item["Lead_Dynamic_Field_Order"] = i;
    item["Lead_Dynamic_Field_Type"] = type;
    item["Lead_Dynamic_User_Display"] = isDisplay;
    item["Lead_Dynamic_Reuse_Field"] = isReuse;
    item["Lead_Dynamic_Download_Name"] = isDownloadName;
    item["Lead_Dynamic_Read_Only"] = isReadOnly;
    item["Lead_Dynamic_Include_In_Email_Subject"] =
      isIncludeInEmailSubject === undefined ? false : isIncludeInEmailSubject;
    if (isRequired) {
      item["Lead_Dynamic_Field_Validation"] = "required";
    }
    item["Lead_Dynamic_Is_Subject"] = element.fields.isSubject;
    item["Lead_Dynamic_Is_Visible_For_Inbox"] =
      element.fields.isVisibleForInbox;
    item["Lead_Dynamic_Display_Recipeints_Inbox"] =
      element.fields.showMailInInbox;

    let res = { item: item, message: "" };
    var title = "";
    var isValidField;

    switch (type) {
      case "text":
        isValidField = true;
        if (isRequired && !isReadOnly) {
          if (validation_IsEmpty(element.TextValue)) {
            //SetError(C_EmbedValidateEnter + ' ' + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);
            //return res;
          }
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = element.fields.label;
        item["Lead_Dynamic_Field_Value"] = element.TextValue;
        break;
      case "url":
        isValidField = true;
        if (validation_IsEmpty(element.TextValue)) {
          if (isRequired && !isReadOnly) {
            //SetError(C_EmbedValidateEnter + " " + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);
            //return res;
          }
        } else {
          if (!isReadOnly) {
            if (!validation_IsValidUrl(element.TextValue.trim())) {
              //SetError(title + " " + C_EmbedValidateInvalid1, null);
              leadsJson = [];
              isValidField = false;
              res.message = "invalid";
              errorFields.push(res);
              //return res;
            }
          }
        }
        if (isRequired) {
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = element.fields.label;
        item["Lead_Dynamic_Field_Value"] = element.TextValue
          ? element.TextValue.trim()
          : "";
        if (isValidField) {
        }
        break;
      case "email":
        isValidField = true;
        if (validation_IsEmpty(element.TextValue)) {
          if (isRequired && !isReadOnly) {
            //SetError(C_EmbedValidateEnter + " " + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);

            //return res;
          }
        } else {
          if (!isReadOnly) {
            if (!validation_IsValidEmail(element.TextValue.trim())) {
              //SetError(title + " " + C_EmbedValidateInvalid1, null);
              leadsJson = [];
              isValidField = false;
              res.message = "invalid";
              errorFields.push(res);

              //return false;
            }
          }
        }
        if (isRequired) {
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = element.fields.label;
        item["Lead_Dynamic_Field_Value"] = element.TextValue
          ? element.TextValue.trim()
          : "";
        if (isValidField) {
        }
        break;
      case "number":
        isValidField = true;
        var number = element.TextValue;
        title = element.fields.label;
        if (validation_IsEmpty(number)) {
          if (isRequired && !isReadOnly) {
            //SetError(C_EmbedValidateEnter + " " + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);

            //return res;
          }
        } else {
          if (!isReadOnly) {
            number = number.trim();
            if (!number) {
              //SetError(title + " " + C_EmbedValidateInvalid2, null);
              leadsJson = [];
              isValidField = false;
              res.message = "invalid";
              errorFields.push(res);

              //return res;
            }
          }
        }
        if (isRequired) {
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = element.fields.label;
        item["Lead_Dynamic_Field_Value"] = number;
        if (isValidField) {
        }
        break;
      case "datepick":
        isValidField = true;
        var date = element.TextValue
          ? displayDate(new Date(element.TextValue))
          : "";
        title = element.fields.label;
        if (validation_IsEmpty(date)) {
          if (isRequired && !isReadOnly) {
            //SetError(C_EmbedValidateEnter + " " + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);

            //return res;
          } else {
            date = "";
          }
        } else {
          if (!isReadOnly) {
            if (!validation_IsValidDate(date)) {
              //SetError(title + " " + C_EmbedValidateInvalid2, null);
              leadsJson = [];
              isValidField = false;
              res.message = "invalid";
              errorFields.push(res);

              //return res;
            }
          }
        }
        if (isRequired) {
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = element.fields.label;
        item["Lead_Dynamic_Field_Value"] = date;
        if (isValidField) {
        }
        break;
      case "textarea":
        isValidField = true;
        var textarea = element.TextValue;
        title = element.fields.label;
        if (isRequired) {
          if (validation_IsEmpty(textarea)) {
            //SetError(C_EmbedValidateEnter + " " + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);

            //return res;
          }
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = title;
        item["Lead_Dynamic_Field_Value"] = textarea;
        if (isValidField) {
        }
        break;
      case "radiolist":
        title = element.fields.label;
        if (isRequired && !isReadOnly) {
          if (!element.TextValue) {
            //SetError(C_EmbedValidateMustSelect + " " + title, null);
            leadsJson = [];
            res.message = "isRequired";
            errorFields.push(res);
            //return res;
          }
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = title;
        item["Lead_Dynamic_Field_Value"] = element.TextValue;
        break;
      case "checkboxlist":
        title = element.fields.label;
        if (isRequired && !isReadOnly) {
          if (!element.TextValue) {
            //SetError(C_EmbedValidateMustSelect + " " + title, null);
            leadsJson = [];
            res.message = "isRequired";
            errorFields.push(res);

            //return res;
          }
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = title;
        item["Lead_Dynamic_Field_Value"] = element.TextValue;
        break;
      case "selectlist":
        isValidField = true;
        title = element.fields.label;
        let itemR = element.TextValue;
        if (itemR === title) {
          if (isRequired && !isReadOnly) {
            //SetError(C_EmbedValidateEnter + " " + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            //faildFiles.push(res);

            //return res;
          } else {
            itemR = null;
          }
        }

        if (isRequired && !isReadOnly) {
          if (
            itemR === "" ||
            itemR === null ||
            element.TextValue.length === 0
          ) {
            //SetError(C_EmbedValidateMustSelect + " " + title, null);
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);

            //return res;
          }
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = title;
        item["Lead_Dynamic_Field_Value"] = itemR;
        if (isValidField) {
        }
        break;
      case "recipientDropdown":
        isValidField = true;
        if (isRequired) {
          // Проверяем есть ли выбранные получатели
          if (
            !element.fields.dropdownSavedRecipients ||
            element.fields.dropdownSavedRecipients.length === 0
          ) {
            leadsJson = [];
            isValidField = false;
            res.message = "isRequired";
            errorFields.push(res);
          }
          item["Lead_Dynamic_Field_Validation"] = "required";
        }
        item["Lead_Dynamic_Field_Name"] = element.fields.label;
        // Преобразуем массив объектов в JSON строку
        item["Lead_Dynamic_Field_Value"] = element.fields
          .dropdownSavedRecipients
          ? JSON.stringify(element.fields.dropdownSavedRecipients)
          : "";
        item["Lead_Dynamic_Display_Recipeints_Inbox"] =
          element.fields.showMailInInbox;
        break;
      default:
        break;
    }
    leadsJson.push(item);
  }

  if (errorFields.length > 0) {
    return { list: errorFields, status: "error" };
  } else {
    return { list: leadsJson, status: "success" };
  }
};

export const validateEmbedFormats = ({ formatsAction, formats, files }) => {
  let result = [true, null];
  if (
    formatsAction === null ||
    formatsAction === undefined ||
    formatsAction === "" ||
    formatsAction.length <= 0
  ) {
    return result;
  }

  if (
    formats === null ||
    formats === undefined ||
    formats === "" ||
    formats.length <= 0
  ) {
    return result;
  }

  let uploadFormatsList = [];

  for (let i = 0; i < files.length; i++) {
    let fileFormat = files[i].extension || files[i].file.extension;
    if (
      fileFormat !== null &&
      fileFormat !== undefined &&
      fileFormat !== "" &&
      fileFormat.length > 0
    ) {
      uploadFormatsList.push(fileFormat.toLowerCase());
    }
  }

  let arrayCheck = null;
  switch (formatsAction) {
    case "only":
      arrayCheck = uploadFormatsList.filter(function (f) {
        return formats.indexOf(f) < 0;
      });

      if (arrayCheck) {
        if (arrayCheck.length > 0) {
          return [false, null];
        }
      }
      break;
    case "exclude":
      arrayCheck = uploadFormatsList.filter(function (f) {
        return formats.indexOf(f) > 0;
      });

      if (arrayCheck) {
        if (arrayCheck.length > 0) {
          return [null];
        }
      }
      break;
    default:
      break;
  }
  return [true, uploadFormatsList];
};

export const getPrevCookiesValues = (cookies) => {
  let cookiesObject = {};
  if (cookies.length > 0) {
    let splitedValues = cookies.split("#");
    for (let y = 0; y < splitedValues.length; y++) {
      let splitedLead = splitedValues[y].split("&");
      if (splitedLead.length > 0) {
        for (let i = 0; i < splitedLead.length; i++) {
          const element = splitedLead[i];
          let splitKeyValue = element.split("^");
          let fieldCookieValue = splitKeyValue[1];
          if (splitKeyValue.length > 0) {
            let splitField = splitKeyValue[0];
            let numField = splitField.split("=")[0].split("field")[1];
            cookiesObject[numField] = fieldCookieValue;
          }
        }
      }
    }
  }

  return cookiesObject;
};

export const displayDate = (date) => {
  let displayDate = null;
  if (date) {
    let day = date.getDate() <= 9 ? "0" + date.getDate() : date.getDate();
    let month =
      date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1);
    displayDate = day + "/" + month + "/" + date.getFullYear();
  }

  return displayDate;
};

//Check background color, if dark set texts in white
export const checkIfColorIsDark = (color) => {
  if (color) {
    const c = color.replace("#", "");
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq < 140;
  }
};
